module.exports = __webpack_public_path__ + "static/media/sig.1273606f.png";